import { ALIGNS } from "../consts";
export var isAlignCenter = function isAlignCenter(a) {
  return a === ALIGNS.CENTER;
};
export var isAlignStart = function isAlignStart(a) {
  return a === ALIGNS.START;
};
export var isAlignEnd = function isAlignEnd(a) {
  return a === ALIGNS.END;
};